import { useContext } from 'react';
import styles from './PageProductCallToActionBasicPrice.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import classNames from 'classnames';
import ProductsContext from '../contexts/ProductsContext.js';

function PageProductCallToActionBasicPrice() {
  const {
    showCallToActionPriceIntervalCount,
    showCallToActionPriceIntervalCountVerbose,
    showCallToActionRenewAtCurrentRateButton,
    productSku: productProp,
  } = useSearchParamOrDefaultProps();
  const products = useContext(ProductsContext);

  const product = products[productProp];
  const { rate_plans: ratePlans } = product;
  const [{ prices }] = ratePlans;

  // Discount may not always exist but when it does it takes precedence
  // from a UI perspective and is the primary offer to display. Keep in mind
  // we are at a single product at this point and the expectation
  // is that the discount is the primary price to display.
  const [originalRatePlan, discountRatePlan = {}] = prices.sort(
    ({ amount_usd: aAmountUSD }, { amount_usd: bAmountUSD }) =>
      bAmountUSD - aAmountUSD,
  );

  const {
    amount_usd: originalRatePlanAmountUSD,
    interval: originalRatePlanInterval,
    interval_count: originalRatePlanIntervalCount,
  } = originalRatePlan;
  const {
    amount_usd: discountRatePlanAmountUSD,
    interval: discountRatePlanInterval,
    interval_count: discountRatePlanIntervalCount,
  } = discountRatePlan;

  const ratePlanCurrency = '$';

  // Discounts take precedence over original rate plan values
  const targetRatePlanIntervalCount =
    discountRatePlanIntervalCount || originalRatePlanIntervalCount;
  const targetRatePlanInterval =
    discountRatePlanInterval || originalRatePlanInterval;
  const targetRatePlanAmountUSD =
    discountRatePlanAmountUSD || originalRatePlanAmountUSD;
  return (
    <span className={styles.PageProductCallToActionBasicPrice}>
      {discountRatePlanAmountUSD && (
        <s className={styles.strikethrough}>
          {ratePlanCurrency}
          {originalRatePlanAmountUSD}
        </s>
      )}
      <span className={styles.priceIntervalWrapper}>
        <span className={styles.price}>
          {ratePlanCurrency}
          {targetRatePlanAmountUSD}
        </span>
        {showCallToActionPriceIntervalCount === 'true' &&
          showCallToActionPriceIntervalCountVerbose === 'true' && (
            <>
              <span className={styles.interval}>/{targetRatePlanInterval}</span>
              <span
                className={classNames(styles.intervalCount, {
                  [styles.intervalCountBlock]:
                    showCallToActionRenewAtCurrentRateButton !== true,
                })}
              >
                {`for ${targetRatePlanIntervalCount} ${targetRatePlanInterval}${
                  targetRatePlanIntervalCount === 1 ? '' : 's'
                }`}
              </span>
            </>
          )}
      </span>
      {showCallToActionPriceIntervalCount === 'true' &&
        showCallToActionPriceIntervalCountVerbose !== 'true' && (
          <span className={styles.interval}>/{targetRatePlanInterval}</span>
        )}
    </span>
  );
}

export default PageProductCallToActionBasicPrice;
